import React from "react";
import { Stack } from "@mui/material";

import { JOB_STATUSES, JOB_STATUS_IDS } from "../../constants/jobs";
import { HubFilterMenu, HubHookFormWrapper } from "../../components";
import ContactsLocationFilter from "../../pages/Companies/ContactsLocationFilter";

const options = [
  {
    id: JOB_STATUS_IDS.NOT_STARTED,
    label: JOB_STATUSES.NOT_STARTED,
  },
  {
    id: JOB_STATUS_IDS.IN_PROGRESS,
    label: JOB_STATUSES.IN_PROGRESS,
  },
  {
    id: JOB_STATUS_IDS.COMPLETE,
    label: JOB_STATUSES.COMPLETE,
  },
];

const JobsFilters = () => {
  const defaultStatus = [JOB_STATUS_IDS.NOT_STARTED, JOB_STATUS_IDS.IN_PROGRESS];

  return (
    <HubHookFormWrapper onSubmit={() => {}} sx={{ width: "fit-content" }}>
      <Stack direction="row" gap="5px">
        <ContactsLocationFilter />
        <HubFilterMenu
          id="status"
          options={options}
          menuLabel="Filter orders by their status"
          label="Status"
          defaultValue={defaultStatus}
        />
      </Stack>
    </HubHookFormWrapper>
  );
};

export default JobsFilters;
